// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import TransitionsPage from './TransitionsPage';
import InteractivePage from './InteractivePage';
import ScrollPage from './ScrollPage';

export default function AnimationsRoutes() {
  return (
    <Routes>
      <Route path="transitions" element={<TransitionsPage />} />
      <Route path="interactive" element={<InteractivePage />} />
      <Route path="scroll" element={<ScrollPage />} />
    </Routes>
  );
}
